import { Routes } from '@angular/router';
import { AuthGuard } from './auth-guard';

export const routes: Routes = [
  // =========================
  // Public pages
  // =========================

  // Public login page
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login-component').then(m => m.LoginComponent)
  },

  // ✅ PUBLIC RESET PASSWORD PAGE (FROM EMAIL LINK - forgot password flow)
  // Example: /reset-password?code=abc123
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./reset-password/reset-password.component')
        .then(m => m.ResetPasswordComponent)
  },

  // ✅ PUBLIC SET PASSWORD PAGE (FROM EMAIL LINK - new customer invite flow)
  // Example: /set-password?code=abc123
  {
    path: 'set-password',
    loadComponent: () =>
      import('./set-password/set-password.component')
        .then(m => m.SetPasswordComponent)
  },

  // =========================
  // Authenticated area
  // =========================
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadComponent: () =>
      import('./customer-layout.component').then(m => m.CustomerLayout),
    children: [

      { path: '', pathMatch: 'full', redirectTo: 'customer-management' },

      // CUSTOMER MANAGEMENT
      {
        path: 'customer-management',
        loadComponent: () =>
          import('./customer-management/customer-management.component')
            .then(m => m.CustomerManagementComponent)
      },

      // BILLING
      {
        path: 'billing',
        loadComponent: () =>
          import('./billing/billing.component')
            .then(m => m.BillingComponent)
      },

      // SUPPORT (Ticket Management)
      {
        path: 'ticket',
        loadComponent: () =>
          import('./ticket-management/ticket-management.component')
            .then(m => m.TicketManagementComponent),
        data: { title: 'SUPPORT & REQUESTS' }
      },

      // CONTACT
      {
        path: 'contact',
        loadComponent: () =>
          import('./contact/contact-component')
            .then(m => m.ContactPageComponent)
      },

      // PROFILE PAGE
      {
        path: 'profile',
        loadComponent: () =>
          import('./profile/profile.component')
            .then(m => m.ProfileComponent)
      }
    ]
  },

  // Fallback
  { path: '**', redirectTo: 'login' }
];
